import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchStripeToken,StripeCharge } from "../services/payStripeService";

export const createStripeToken = createAsyncThunk(
  "payStripe/createStripeToken",
  async (cardDetails, { rejectWithValue }) => {
    try {
      // Fetch Stripe token
     
      const response = await fetchStripeToken(cardDetails);

      if (response.status === 200) {       
        const stripeResponse = await StripeCharge(
          cardDetails.order_ids, // Ensure order_ids is an array
          response.data
        );

        return stripeResponse;
      }

      throw new Error("Invalid Stripe token response");
    } catch (error) {
      console.error("Stripe token error:", error);

      if (error.response?.status === 403) {
        return rejectWithValue("Payment failed. Please check your card details.");
      }

      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch Stripe token"
      );
    }
  }
);



const payStripeSlice = createSlice({
  name: "payStripe",
  initialState: {
    token: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createStripeToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createStripeToken.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload;
      })
      .addCase(createStripeToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default payStripeSlice.reducer;
